module.exports = __webpack_public_path__ + "img/out.3eff06c7.png";